/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { IoCloseSharp } from 'react-icons/io5';
import ManageCriteria from './manageCriteria';
import TeamDropDown from './teamDropDown';
import TypeDropDown from './typeDropDown';
import { allows } from '../../utils/authorization';
import { currentOrganization } from '../../utils/organizationHelpers';

class CriteriaModal extends Component {
  constructor(props) {
    super(props);
    const defaultTeamId = props.defaultTeam && props.defaultTeam.id;

    this.state = {
      selectedTeamId: defaultTeamId || props.teams[0].id,
      acInputType: ''
    };
  }

  handleTeamChange = (value) => {
    this.setState({
      selectedTeamId: parseInt(value, 10)
    });
  };

  handleInputTypeChange = (value) => {
    this.setState({
      acInputType: value
    });
  };

  handleEditInputType = (value) => {
    this.setState({
      acInputType: value
    });
  };

  generateOptionValue = (name) =>
    // const splitName = name.split(' ');
    // return splitName.join(' ');
    name;

  generateHeaderText = () => {
    switch (this.props.type) {
      case 'ready':
        return 'Criteria needed to make work READY';
      case 'done':
        return 'Criteria needed to ACCEPT work';
      case 'shippable':
        return 'Criteria needed to SHIP work';
      default:
    }
  };

  render() {
    const { isOpen, type, onClose, teams, organizationLevels } = this.props;
    const { selectedTeamId, acInputType } = this.state;

    if (!isOpen) return null;
    return (
      <div
        className="detail-modal workpackage-detail"
        tabIndex="-1"
        role="dialog"
      >
        <div className="detail-dialog" role="document">
          <div className="detail-content">
            <div className="modal-header detail-header">
              <div className="col-sm-10 criteria-header">
                Manage {type} criteria
              </div>
              <div className="col-sm-2 form-inline text-center">
                <div className="right detail-close">
                  <button type="button" className="btn-close" onClick={onClose}>
                    <IoCloseSharp size="2em" />
                  </button>
                </div>
              </div>
            </div>
            <div
              className="modal-body criteria-modal-body"
              style={{ backgroundColor: 'white' }}
            >
              <div className="criteria-select-header">
                <div className="team-dropdown-container">
                  <label htmlFor="team">Team</label>
                  <TeamDropDown
                    selectedTeamId={selectedTeamId}
                    handleTeamChange={this.handleTeamChange}
                    teams={teams}
                  />
                </div>
                <div className="type-dropdown-container">
                  <label htmlFor="type">Type</label>
                  <TypeDropDown
                    handleInputTypeChange={this.handleInputTypeChange}
                    acInputType={acInputType}
                    organizationLevels={organizationLevels}
                    generateOptionValue={this.generateOptionValue}
                  />
                </div>
              </div>
              <span className="manage-criteria-acceptace-header">
                {this.generateHeaderText()}
              </span>
              <ManageCriteria
                type={type}
                teamId={selectedTeamId}
                acInputType={acInputType}
                handleEditInputType={this.handleEditInputType}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CriteriaModal.propTypes = {
  type: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

const mapStateToProps = (state) => {
  const teamsWhereUserIsAdmin = state.teamReducer.teams.filter(
    (team) =>
      !team.deleted_at &&
      allows('create_criteria', team, 'team') &&
      allows('update_criteria', team, 'team') &&
      allows('destroy_criteria', team, 'team')
  );

  const { selectedSpace } = state.workPackageReducer;

  const selectedSpaceIsTeam = !!selectedSpace.products;

  const defaultTeam =
    (selectedSpaceIsTeam && selectedSpace) ||
    state.userReducer.user.default_team;

  const organizationLevels = currentOrganization().organization_levels || [];

  return {
    organizationLevels: organizationLevels.filter(
      (orgLevel) => orgLevel.level === 1 && !orgLevel.deleted_at
    ),
    teams: teamsWhereUserIsAdmin,
    defaultTeam
  };
};

export default connect(mapStateToProps)(CriteriaModal);
